import { render, staticRenderFns } from "./29threehuanghuacai.vue?vue&type=template&id=084acdef&"
import script from "./29threehuanghuacai.vue?vue&type=script&lang=js&"
export * from "./29threehuanghuacai.vue?vue&type=script&lang=js&"
import style0 from "./29threehuanghuacai.vue?vue&type=style&index=0&id=084acdef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports